import { proxy, useSnapshot } from 'valtio';

export type OverlayStatus = 'OPEN' | 'CLOSE';

interface CountrySelectorState {
  overlayStatus?: OverlayStatus;
}

export const countrySelectorActions = {
  changeOverlayStatus: (status: OverlayStatus) => {
    countrySelectorState.overlayStatus = status;
  },
};

export const countrySelectorState = proxy<CountrySelectorState>({
  overlayStatus: 'CLOSE',
});

export const useCountrySelectorState = () => useSnapshot(countrySelectorState);
